import { gql, type OperationVariables } from '@apollo/client';
import type ICompanySettings from '@sharedInterfaces/ICompanySettings';
import Company from '@src/Objects/Company';
import { deleteEmployee as deleteEmployeeReducerAction } from '@store/reducer/employeesReducer';
import store from '@store/store';
import { companySettingsGql } from '../Company/getCompanySettings';
import GraphQL from '../graphQL';

const query = gql`
mutation deleteEmployee($id: Int!) {
    deleteEmployee(id: $id)
        ${companySettingsGql}
},
`;

/**
 * Deletes an employee from the company.
 *
 * @param {number} id - The ID of the employee to delete.
 * @returns {Promise<Company>} A promise that resolves to the updated company object after the employee deletion.
 */
export default async function deleteEmployee(id: number) {
    const variables: OperationVariables = { id };
    return GraphQL.mutate<ICompanySettings>(query, variables).then((c) => {
        store.dispatch(deleteEmployeeReducerAction(id));
        return new Company(c);
    });
}
